export default __webpack_public_path__ + "2a0c757c00a6d77e639c7f1d547d3532.png";